import React, { useEffect, useState } from "react";
import EmailTagInput from "components/EmailTagInput";
import { SubmitButton } from "components/common/buttons/SubmitButton";
import Api from "services/api";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

const EditDepartmentNotificationModal = ({ item, isOpen, onClose, onSuccess }) => {
  const { t } = useTranslation();
  const [emails, setEmails] = useState([]);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    if (item?.email) {
      const parsed = item.email
        .split(",")
        .map((e) => e.trim())
        .filter(Boolean);
      setEmails(parsed);
    } else {
      setEmails([]);
    }
  }, [item, isOpen]);

  if (!isOpen || !item) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoader(true);
    try {
      const payload = {
        email: emails.join(", "),
      };
      const response = await Api.updateDepartmentNotification(item.id, payload);
      if (response?.status === 200 || response?.data?.success) {
        toast.success(
          response?.data?.message || t("common.updatedSuccessfully", "Updated successfully."),
          { className: "successToast" }
        );
        if (onSuccess) onSuccess();
        onClose();
      } else {
        toast.error(
          response?.data?.message || response?.data?.error || t("common.failedToUpdate", "Failed to update."),
          { className: "errorToast" }
        );
      }
    } catch (err) {
      toast.error(err?.message || t("common.anErrorOccurred", "An error occurred."), {
        className: "errorToast",
      });
    } finally {
      setLoader(false);
    }
  };

  return (
    <>
      <div
        className="modal fade show"
        style={{ display: "block" }}
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content full_modal">
            <div className="modal-header header_modal align-items-center">
              <div></div>
              <h5 className="modal-title_u">
                {t("settings.editDepartmentNotification", "Edit Notification Recipients")}
              </h5>
              <button
                onClick={onClose}
                type="button"
                className="btn-close"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body modal_form_body">
              <form onSubmit={handleSubmit}>
                <div className="row-primary">
                  <h2>{t("settings.departmentName", "Department")}</h2>
                  <input
                    className="input-in type_inp"
                    type="text"
                    value={item.department_name || ""}
                    disabled
                    style={{ backgroundColor: "#f4f4f4", cursor: "not-allowed" }}
                  />
                </div>

                <div className="row-primary mt-3">
                  <h2>{t("settings.recipientEmails", "Recipient Email(s)")}</h2>
                  <div style={{ width: "100%" }}>
                    <EmailTagInput
                      value={emails}
                      placeholder={t("settings.enterEmailsPlaceholder", "Type an email and press Enter")}
                      onChange={(newTags) => setEmails(newTags)}
                    />
                  </div>
                  <small style={{ color: "#777", marginTop: "6px", display: "block" }}>
                    {t(
                      "settings.multipleEmailsHint",
                      "Type an email and press Enter, Tab or Comma to add multiple recipients."
                    )}
                  </small>
                </div>

                <div className="Form-footer mt-4">
                  <button
                    type="button"
                    className="Cancle_button"
                    onClick={onClose}
                    disabled={loader}
                  >
                    {t("common.cancel", "Cancel")}
                  </button>
                  <SubmitButton
                    btnText={t("common.update", "Update")}
                    loader={loader}
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
};

export default EditDepartmentNotificationModal;
